import React from 'react'
import { Outlet } from 'react-router'

const ClientLayout = () => {
    return (
        <Outlet />
    )
}

export default ClientLayout